import React, {useState} from 'react';
import {Grid, Pagination, Stack, Typography} from "@mui/material";
import Search from "../../../../components/Admin/Search/Search";
import {Link, useNavigate} from "react-router-dom";
import ITable from "../../../../components/Admin/table/ITable";
import {GetState, SetState} from "../../../../redux/reduxhelper";
import {useDispatch} from "react-redux";
import {ADD_NEW_BUSINESS_STEPS, CONFIRM_COUNT, OPEN_DELETED_EventItem} from "../../../../redux/action/type.action";
import {useQuery, useQueryClient} from "react-query";
import Loading from "../../../../components/Site/Loading/Loading";
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';
import Divider from "@mui/material/Divider";
import DeleteIcon from '@mui/icons-material/Delete';
import DeleteItem from "./modal/DeleteItem";
import {getEventListApi} from "../../../../api/AdminApi";

const DashboardEvents = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedEventId, setSelectedEventId] = useState(0);
    const [itemId, setItemId] = useState(0)
    const navigate = useNavigate();

    const dispatch = useDispatch();
    const confirmCount = GetState(CONFIRM_COUNT, 0)


    // local variables
    const perPage = 10;
    let rowsData = [];
    let pagination = {
        page: 1,
        defaultPage: 1,
        perPage: 10,
        count: 10,
        from: 1,
        to: 10,
        total: 10,
        prev_page_url: null,
        next_page_url: null,
    };

    // dev react query method
    const getEventList = async () => {
        try {
            const res = await getEventListApi(currentPage, perPage, searchQuery)
            return res?.data

        } catch (e) {

        }
    }

    // search query method
    let count = 0;
    let tempCount = 0;
    const handleSearchQueryChange = (e) => {
        count = count + 1;
        setTimeout(() => {
            if (tempCount + 1 === count) {
                setSearchQuery(e.target.value);
            }
            tempCount = tempCount + 1;

        }, 1000);
    }

    const client = useQueryClient();
    const invalidateData = async ()=>{
        await client.invalidateQueries('event_List')
    }

    const {
        isLoading,
        data: eventList,
        error
    } = useQuery(['event_List', currentPage, confirmCount, searchQuery], getEventList);


    // if (isLoading) return <Loading/>
    // if (error) return <>An error accrued : {error.message}</>

    const loadData = (eventList) => {
        // parse json response
        let responseData = eventList?.data;
        pagination = {
            page: responseData?.current_page,
            defaultPage: 1,
            perPage: responseData?.per_page,
            count: responseData?.last_page,
            from: responseData?.from,
            to: responseData?.to,
            total: responseData?.total,
            links: responseData?.links
        };


        const jsonData = eventList?.data?.data;
        jsonData?.map((item) => {
            rowsData.push({
                id: item?.id,
                title1: item?.title1,
                company_name: item?.title2,
                start_date: item?.start_date,
                program_name: item?.plan?.name,
                details: <Link to={`/admin/dashboard/event/${item.id}`}
                               style={{cursor: "pointer", color: "#000"}}>مشاهده</Link>,
                deleted: <DeleteIcon style={{color: "#592EA9", cursor: "pointer"}}
                                     onClick={() => setItemId(item.id)}/>

            })
        });
    }
    if (!isLoading && !error) loadData(eventList);

    return (

        <Grid container>
            {/*Content Header*/}
            <Typography variant="h6" component="h2"
                        sx={{fontWeight: '600', lineHeight: "38px", margin: "auto", mt: 3}}>
                ایونت ها
            </Typography>

            <Divider sx={{
                width: '100%',
                mb: 4,
                mt: 2,
                height: '2px',
                backgroundColor: 'rgb(89, 46, 169)',
                boxShadow: ' -2px 2px 6px -1px rgb(89, 46, 169)',
            }}/>

            <Search placeholder={"اسم ایونت مورد نظر خود را جستجو کنید"}
                    onChange={(e) => handleSearchQueryChange(e)} defaultValue={searchQuery}/>
            {/*Content Table Rows*/}
            {isLoading && <Loading/>}
            {error && <div>An error accrued : {error.message}</div>}
            {!isLoading &&
                <Grid item xs={12}>
                    <Grid item xs={12}>
                        <ITable
                            haveAnimation
                            notActiveColor={'#f00'}
                            rows={rowsData}
                            titleHeaders={
                                [
                                    "نام ایونت",
                                    "نام شرکت",
                                    "تاریخ",
                                    "برنامه",
                                    "جزئیات",
                                    <AddCircleOutlineRoundedIcon style={{color: "#592EA9"}} onClick={()=>navigate(`/admin/dashboard/event/add`)}/>
                                ]
                            }
                        />
                    </Grid>
                    {/*Content Pagination*/}
                    <Grid item mt={8} xs={12} display={"flex"} alignItems={"center"} justifyContent={"center"}>
                        <Stack>
                            <Pagination onChange={(event, page) => setCurrentPage(page)}
                                        page={pagination.page}
                                        defaultPage={pagination.defaultPage}
                                        count={pagination.count}
                                        hideNextButton={pagination?.next_page_url === null}
                                        hidePrevButton={pagination?.prev_page_url === null}
                                        variant="outlined"
                                        shape="circular"/>
                        </Stack>
                    </Grid>
                </Grid>
            }
            <DeleteItem idItem={selectedEventId} open={itemId > 0} close={() => setItemId(0)} itemId={itemId} invalidateData={invalidateData}/>
        </Grid>


    );
};

export default DashboardEvents;